import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aba6447"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["unfold"]
const _hoisted_2 = { class: "add-external-form-head" }
const _hoisted_3 = { class: "add-external-form-desc" }
const _hoisted_4 = { class: "add-external-form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "IP", -1))
const _hoisted_6 = { class: "add-external-form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "用户名", -1))
const _hoisted_8 = { class: "add-external-form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "密码", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "add-external-form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "通讯协议", -1))
const _hoisted_13 = { class: "add-external-form-item-checkbox-group" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "HTTP", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = ["checked"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "HTTPS", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "add-external-form-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "URL", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "add-external-form-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "用户名", -1))
const _hoisted_27 = { class: "add-external-form-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "密码", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "高级", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "add-external-form-item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "路径", -1))
const _hoisted_35 = { class: "add-external-form-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "端口", -1))
const _hoisted_37 = {
  key: 1,
  class: "add-external-dir"
}
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = ["checked"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 1,
  class: "add-external-dir-empty"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("p", null, "暂无文件夹")
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 2,
  class: "add-external-form-submit"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 0,
  class: "error-message"
}

import { onMounted, computed, ref, onUnmounted } from 'vue'
import {
  previewNetDriveFolderList,
  insertNetDrive,
  IPreviewNetDriveParams,
  ISmbSharedFolderPickItem,
} from '@remote/api/adapter/disk-mqtt'
import { getNetDeiveInfoByUrl } from '@remote/store/hezi-file/disk'
import { normalizeUrl } from '@remote/api/adapter/helper'
import { checkState } from '@remote/store/utils'
import { toast } from '@remote/utils/dialog'
import { FloderIcon } from '@remote/utils/file-helper'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { isLargeViewPort } from '@remote/utils/base'

interface IInputFileEvent extends Event {
  target: HTMLInputElement
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  type: 'samba'|'webdav'
}





const isMountedRef = ref(false)
const { close } = usePromisifyDialog(emit)

const protocolRef = ref('http')
const advancedSettingRef = ref(false)
const inputUrlEleRef = ref<HTMLInputElement>()
const defaultFormValues = {
  url: '',
  user: '',
  password: '',
  path: '',
  port: '',
  protocol: '',
}
const formValues = ref(defaultFormValues)

const isLoading = ref(false)
const externalDir = ref<ISmbSharedFolderPickItem[] | null>(null)
const externalDirSelected = ref<number[]>([])
const errorMessage = ref('')

const submitBtnDisabled = computed(() => {
  if (externalDir.value && !externalDir.value?.length || externalDir.value?.length && !externalDirSelected.value.length) return true
  return !formValues.value.url
})

const headTitle = computed(() => {
  const externalDirSelectedLenth = externalDirSelected.value.length
  if (externalDirSelectedLenth) return `已选择${externalDirSelectedLenth}项`
  if (externalDir.value) return '请选择要添加到迅雷盒子的文件夹'
  return props.type === 'samba' ? '添加Samba' : '添加WebDAV'
})

const subTitle = computed(() => {
  if (externalDir.value) return ''

  return props.type === 'samba' ? '把其他支持Samba的设备添加到迅雷盒子，用迅雷盒子浏览、管理该设备的文件。' :
    '把支持WebDAV协议的设备添加到迅雷盒子，用迅雷盒子浏览、管理该设备的文件。'

})

const handleClose = () => {
  isMountedRef.value = false
  if (isLargeViewPort()) {
    close(null)
  } else {
    setTimeout(() => {
      close(null)
    }, 300)
  }
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  window.document.removeEventListener('keydown', handleOnKeyDownEnter)
}

const toggleProtocol = () => {
  protocolRef.value = protocolRef.value === 'http' ? 'https' : 'http'
  if (formValues.value.url) {
    const { protocol } = getNetDeiveInfoByUrl(formValues.value.url)
    if (protocol && protocol !== protocolRef.value) {
      formValues.value.url = formValues.value.url.replace(protocol, protocolRef.value)
    }
  }
}

const toggleAdvancedSetting = () => {
  advancedSettingRef.value = !advancedSettingRef.value
}

const handleOnFormInput = (evt: IInputFileEvent) => {
  console.log(evt.target.name, evt.target.value)
  let { name, value } = evt.target
  errorMessage.value = ''
  value = value.trim()
  // webdav 输入url逻辑
  // 1.用户输入url中带有协议则切换至对应通信协议单选按钮自动切换对应的协议
  // 2.用户输入无协议拼接url带上协议
  // 3.输入url中有内容用户切换协议自动修改协议
  // 密码输入过滤中文
  if (name === 'password') value = value.replace(/[\u4e00-\u9fa5]/g, '')
  if (name === 'url' && props.type === 'webdav') {
    const { protocol } = getNetDeiveInfoByUrl(value)

    if (protocol) {
      formValues.value.protocol = Object.assign({}, formValues.value, protocol)
      protocolRef.value = protocol
    }
  }

  formValues.value = Object.assign({}, formValues.value, { [name]: value })
}

const handleOnSelectExternalDir = (i: number) => {
  const index = externalDirSelected.value.indexOf(i)
  if (index >= 0) {
    externalDirSelected.value.splice(index, 1)
  } else {
    externalDirSelected.value.push(i)
  }
}

let params: IPreviewNetDriveParams

const handleOnSubmit = () => {
  const checkStateRet = checkState()
  if (checkStateRet) return errorMessage.value = checkStateRet
  if (!externalDirSelected.value?.length && !formValues.value.url) return
  if (!externalDirSelected.value?.length) {
    // 连接外部存储
    if (props.type === 'samba') {
      params = {
        url: normalizeUrl(`smb://${formValues.value.url}`),
        user: formValues.value.user,
        password: formValues.value.password,
      }
    } else {
      let url = formValues.value.protocol ? formValues.value.url : `${protocolRef.value}://${formValues.value.url}`
      if (formValues.value.path) url = `${url}/${formValues.value.path}`
      if (formValues.value.port && parseInt(formValues.value.port)) {
        const u = new URL(url)
        u.port = formValues.value.port
        url = u.href
      }

      params = {
        url: normalizeUrl(url),
        user: formValues.value.user,
        password: formValues.value.password,
      }
      console.log('previewNetDriveFolderList', params)
    }
    isLoading.value = true
    // 获取外部存储目录
    previewNetDriveFolderList(params)
      .then(res => {
        console.log('previewNetDriveFolderList', res)
        externalDir.value = res
      }).catch(err => {
        errorMessage.value = err?.replace(/#.+:\s+/g, '') || '当前外部存储连接失败'
        if (!isLargeViewPort()) toast({ type: 'error', message: err?.replace(/#.+:\s+/g, '') || '当前外部存储连接失败' })
      }).finally(() => {
        isLoading.value = false
      })
  } else {
    Promise.allSettled(externalDirSelected.value.map(index => insertNetDrive({
      url: externalDir.value ? normalizeUrl(`${params.url}/${externalDir.value[index].name}`) : '',
      user: formValues.value.user,
      password: formValues.value.password,
    }))).then(results => {
      const succList = results.filter(result => result.status === 'fulfilled')
      if (succList.length > 0) {
        toast({ type: 'success', message: '连接成功' })
        handleClose()
      } else {
        const rejectItem = results.find(result => result.status === 'rejected') as { status:'fulfilled'|'rejected'; value: {msg:string}}
        errorMessage.value = rejectItem?.value?.msg || '连接失败'
        if (!isLargeViewPort()) toast({ type: 'error', message: rejectItem?.value?.msg || '连接失败' })
      }
    })
  }
}

const handleOnKeyDownEnter = (e) => {
  if(e.keyCode==13) handleOnSubmit()
}

onMounted(() => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
  setTimeout(() => {
    inputUrlEleRef.value?.focus()
  }, 100)
  window.document.addEventListener('keydown', handleOnKeyDownEnter)
})

onUnmounted (() => {
  window.document.removeEventListener('keydown', handleOnKeyDownEnter)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["add-external-form-wrap", { 'is-mounted': isMountedRef.value }])
  }, [
    (isMountedRef.value || !_unref(isLargeViewPort)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["add-external-form", props.type]),
          unfold: advancedSettingRef.value
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_unref(headTitle)), 1),
            _createElementVNode("a", {
              href: "javascript:;",
              class: "qh-icon-close",
              title: "返回",
              onClick: handleClose
            })
          ]),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(subTitle)), 1),
          (!externalDir.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (props.type === 'samba')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("input", {
                          placeholder: "必填。例 192.168.11.111",
                          name: "url",
                          onInput: handleOnFormInput,
                          autocomplete: "off",
                          ref_key: "inputUrlEleRef",
                          ref: inputUrlEleRef
                        }, null, 544)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("input", {
                          placeholder: "若匿名访问，则无需填写",
                          name: "user",
                          onInput: handleOnFormInput,
                          autocomplete: "off"
                        }, null, 32)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("input", {
                          placeholder: "若匿名访问，则无需填写",
                          name: "password",
                          onInput: handleOnFormInput,
                          value: formValues.value.password,
                          autocomplete: "off"
                        }, null, 40, _hoisted_10)
                      ])
                    ], 64))
                  : (props.type === 'webdav')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", {
                              class: "add-external-form-item-checkbox-item",
                              checked: protocolRef.value === 'http',
                              onClick: toggleProtocol
                            }, _hoisted_17, 8, _hoisted_14),
                            _createElementVNode("div", {
                              class: "add-external-form-item-checkbox-item",
                              checked: protocolRef.value === 'https',
                              onClick: toggleProtocol
                            }, _hoisted_21, 8, _hoisted_18)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("input", {
                            placeholder: "必填。http://192.168.11.111/dav/",
                            name: "url",
                            onInput: handleOnFormInput,
                            value: formValues.value.url,
                            autocomplete: "off"
                          }, null, 40, _hoisted_24)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("input", {
                            placeholder: "若匿名访问，则无需填写",
                            name: "user",
                            onInput: handleOnFormInput,
                            autocomplete: "off"
                          }, null, 32)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("input", {
                            placeholder: "若匿名访问，则无需填写",
                            name: "password",
                            onInput: handleOnFormInput,
                            value: formValues.value.password,
                            autocomplete: "off"
                          }, null, 40, _hoisted_29)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["add-external-form-item advanced-setting", { fold: advancedSettingRef.value }]),
                          onClick: toggleAdvancedSetting
                        }, _hoisted_32, 2),
                        (advancedSettingRef.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("input", {
                                  placeholder: "非必填。填写路径必需以/开头",
                                  name: "path",
                                  onInput: handleOnFormInput,
                                  autocomplete: "off"
                                }, null, 32)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("input", {
                                  placeholder: "一般默认填写5005",
                                  name: "port",
                                  onInput: handleOnFormInput,
                                  autocomplete: "off"
                                }, null, 32)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                (externalDir.value?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(externalDir.value, (dir, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "add-external-dir-item",
                        onClick: ($event: any) => (handleOnSelectExternalDir(i)),
                        disabled: dir.selected,
                        key: dir.name
                      }, [
                        _createElementVNode("i", {
                          checked: externalDirSelected.value?.includes(i)
                        }, null, 8, _hoisted_39),
                        _createElementVNode("img", { src: _unref(FloderIcon) }, null, 8, _hoisted_40),
                        _createElementVNode("span", null, _toDisplayString(dir.name), 1)
                      ], 8, _hoisted_38))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
              ])),
          (!(externalDir.value && !externalDir.value?.length) || _unref(isLargeViewPort)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("span", {
                  onClick: handleOnSubmit,
                  disabled: _unref(submitBtnDisabled) || isLoading.value,
                  tabindex: "1"
                }, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(isLoading.value ? '确定中' : externalDirSelected.value.length ? `确定(${externalDirSelected.value.length})` : '确定'), 1)
                ], 8, _hoisted_45),
                _createElementVNode("span", { onClick: handleClose }, "取消"),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(errorMessage.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})